"use client";

import Header from "@/src/design-system/components/Header/Header";
import Menu from "@/src/design-system/components/Menu/Menu";
import MenuItem from "@/src/design-system/components/Menu/MenuItem";
import type { Event, Page } from "@/src/generated/prisma/client";
import type IProfile from "@/src/modules/profile/types/IProfile";
import ProfileRole from "@/src/modules/profile/types/ProfileRole";
import { useState } from "react";

interface IEventMenuProps {
  profile: IProfile;
  event: Event;
  pages?: Page[];
}

export default function EventMenu({ profile, event, pages = [] }: IEventMenuProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <Header
        profileHref="/user/account"
        profileChildren={profile.name ? profile.name.charAt(0).toUpperCase() : "2"}
        logoHref={`/dashboard/events/${event.id}`}
        onBurgerMenuClick={toggleMenu}
      />
      <Menu isOpen={isMenuOpen} onClose={toggleMenu}>
        <MenuItem href="/dashboard">Retour à la Galaxie</MenuItem>
        <MenuItem href={`/dashboard/events/${event.id}`}>{event.name}</MenuItem>
        <MenuItem href={`/dashboard/events/${event.id}/routes`}>Parcours</MenuItem>
        <MenuItem href={`/events/${event.id}/ranking/scratch`}>Classements</MenuItem>

        {pages.map((page) => {
          return (
            <MenuItem href={`/dashboard/events/${event.id}/${page.id}`} key={page.id}>
              {page.title}
            </MenuItem>
          );
        })}

        {profile.roles.includes(ProfileRole.ADMIN) ? (
          <MenuItem href="/admin/home">Administration</MenuItem>
        ) : null}
      </Menu>
    </>
  );
}
